export default "__VITE_ASSET__DI35idQb__"